import React from 'react';
import Icon from '../../../components/AppIcon';

const PasswordStrengthIndicator = ({ password = '' }) => {
  const calculateStrength = () => {
    let strength = 0;
    if (password?.length >= 8) strength++;
    if (password?.length >= 12) strength++;
    if (/[a-z]/?.test(password) && /[A-Z]/?.test(password)) strength++;
    if (/\d/?.test(password)) strength++;
    if (/[^a-zA-Z0-9]/?.test(password)) strength++;
    return strength;
  };

  let strength = calculateStrength();

  const getStrengthLabel = () => {
    if (strength === 0) return { text: '', color: '' };
    if (strength <= 2) return { text: 'Faible', color: 'var(--color-error)' };
    if (strength <= 3) return { text: 'Moyen', color: 'var(--color-warning)' };
    if (strength <= 4) return { text: 'Bon', color: 'var(--color-accent)' };
    return { text: 'Excellent', color: 'var(--color-success)' };
  };

  const strengthLabel = getStrengthLabel();

  const requirements = [
    { text: 'Au moins 8 caractères', met: password?.length >= 8 },
    { text: 'Majuscules et minuscules', met: /[a-z]/?.test(password) && /[A-Z]/?.test(password) },
    { text: 'Au moins un chiffre', met: /\d/?.test(password) },
    { text: 'Caractère spécial (!@#$%)', met: /[^a-zA-Z0-9]/?.test(password) }
  ];

  if (!password) return null;

  return (
    <div style={{
      marginTop: 'var(--spacing-sm)',
      padding: 'var(--spacing-sm)',
      background: 'var(--color-muted)',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 'var(--spacing-xs)'
      }}>
        <span style={{
          fontFamily: 'var(--font-caption)',
          fontSize: '0.75rem',
          color: 'var(--color-muted-foreground)',
          fontWeight: 500
        }}>
          Force du mot de passe
        </span>
        {strengthLabel?.text && (
          <span style={{
            fontFamily: 'var(--font-caption)',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: strengthLabel?.color
          }}>
            {strengthLabel?.text}
          </span>
        )}
      </div>
      <div style={{
        display: 'flex',
        gap: '4px',
        marginBottom: 'var(--spacing-sm)'
      }}>
        {[1, 2, 3, 4, 5]?.map((level) => (
          <div
            key={level}
            style={{
              flex: 1,
              height: '4px',
              borderRadius: '2px',
              background: level <= strength ? strengthLabel?.color : 'var(--color-border)',
              transition: 'all var(--transition-base)'
            }}
          />
        ))}
      </div>
      <ul style={{
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}>
        {requirements?.map((req, index) => (
          <li key={index} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--spacing-xs)',
            fontFamily: 'var(--font-caption)',
            fontSize: '0.75rem',
            color: req?.met ? 'var(--color-success)' : 'var(--color-muted-foreground)'
          }}>
            <Icon 
              name={req?.met ? "CheckCircle2" : "Circle"} 
              size={12}
              color={req?.met ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
            />
            <span>{req?.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrengthIndicator;